




























































































import { AuthStoreHelper, RootStoreHelper, StoreHelper } from '../../core/mixins';
import { JourneysService } from '../api/JourneysService';
import store, { AuthEvent, GetterType } from '../../../store';
import { Component, Prop, Vue, Emit, Mixins, Watch } from 'vue-property-decorator';
import { formatDate } from '../../core/utils';
import { EventBus, TypeEventBus } from '../../core/utils';
import moment from 'moment';
import Axios from 'axios';

@Component({
    components: {}
})
export default class CommentsSection extends Mixins(AuthStoreHelper, StoreHelper, RootStoreHelper) {
    comentarios: any = [];
    @Prop() comments: any[];
    valid: boolean = false;
    showResults: boolean = false;
    processingRequest: boolean = false;
    btnAgregarVisible: boolean = false;
    commentRules: any = [
        value => value.length <= 150 || 'Max 150 caracteres',
        value => value.length >= 8 || 'Debe ingresar al menos 8 caracteres'
    ];
    userComment: string = '';
    result: object = {
        msg: '',
        end: null
    };
    msgBox: boolean = false;
    loadingCircle: boolean = true;
    expandComment: boolean = true;

    get form(): Vue & { validate: () => boolean } {
        return this.$refs.form as Vue & { validate: () => boolean };
    }

    mounted() {
        this.comentarios = this.comments;
        EventBus.$on(TypeEventBus.PROCESSING_EVENTS, () => {
            this.processingRequest = true;
        });
        EventBus.$on(TypeEventBus.EVENTS_REFRESHED, (response, newEventAdded) => {
            this.processingRequest = false;
            this.showResults = true;
            if (newEventAdded) {
                this.refreshEvents(response, newEventAdded, 'success');
            }
        });
    }

    @Watch('comments')
    watchComments(value) {
        this.comentarios = value;
    }

    getCurrentJourneyId() {
        return this.$route.params.id;
    }

    updated() {}

    submit() {
        let self = this;
        if (this.form.validate()) {
            this.processingRequest = true;
            let configuration = {
                id: self.getCurrentJourneyId(),
                commentary: this.userComment
            };
            let _this = this;

            JourneysService.postAddCommentJourney(configuration)
                .then(response => {
                    _this.newCommentAdded(response);
                    _this.loadMessage(response.message, true);
                })
                .catch(error => {
                    if (error && error.message) {
                        _this.loadMessage(error.message, false);
                    } else {
                        _this.loadMessage('Ocurrió un error', false);
                    }

                    setTimeout(function() {
                        _this.msgBox = false;
                    }, 2000);
                });
        } else {
            // window.console.log("false");
        }
    }

    blurComment() {
        this.$_enableListenkey;
    }

    keyUpComment() {
        if (this.userComment !== '') {
            this.$_disableListenkey;
            this.btnAgregarVisible = true;
        } else {
            this.btnAgregarVisible = false;
        }
    }

    loadMessage(message: string, end: boolean) {
        this.result = {
            msg: message,
            end: end
        };
        this.msgBox = true;
        setTimeout(() => {
            this.msgBox = false;
        }, 3000);
    }

    newCommentAdded(response) {
        let currentJourneyId = this.getCurrentJourneyId();
        this.refreshEvents(response, response[currentJourneyId], 'success');
    }

    deleteCommentary(id) {
        let counter = 0;
        EventBus.$emit(TypeEventBus.CLOSE_MODAL_CONFIRMATION);
        EventBus.$emit(TypeEventBus.OPEN_MODAL_CONFIRMATION, 'deleteCommentary');
        let _this = this;
        EventBus.$on(TypeEventBus.DELETE_COMMENTARY, () => {
            counter++;
            if (counter == 1) {
                JourneysService.deleteCommentary(id.toString(), Axios.CancelToken.source())
                    .then(response => {
                        _this.refreshEvents(response, false, 'success');
                    })
                    .catch(error => {
                        _this.refreshEvents(error.response.data, false, 'error');
                    });
            }
        });
    }

    refreshEvents(response, newEventAdded, status) {
        this.showResults = true;
        this.processingRequest = true;
        let self = this;

        if (status === 'success' && response.message === 'El comentario fue eliminado') {
            //get id comentario
            //quitar comentario de la lista
            EventBus.$emit(TypeEventBus.REMOVE_COMMENTARY_DELETED, response.id);
            EventBus.$on(TypeEventBus.COMMENTARY_DELETED_FROM_LIST, () => {
                this.loadMessage('Comentario Eliminado', true);
            });
        } else if (status === 'error') {
            this.loadMessage(response.message, false);
        }

        if (newEventAdded) {
            let journeyId = this.getCurrentJourneyId();
            if (this.comentarios.length !== 0) {
                self.comentarios.unshift({
                    date: response[journeyId]['new_registry']['date'],
                    description: response[journeyId]['new_registry']['description'],
                    event: response[journeyId]['new_registry']['event'],
                    user: response[journeyId]['new_registry']['user'],
                    id: response[journeyId]['new_registry']['id']
                        ? response[journeyId]['new_registry']['id']
                        : undefined
                });
            } else {
                self.comentarios.push({
                    date: response[journeyId]['new_registry']['date'],
                    description: response[journeyId]['new_registry']['description'],
                    event: response[journeyId]['new_registry']['event'],
                    user: response[journeyId]['new_registry']['user'],
                    id: response[journeyId]['new_registry']['id']
                        ? response[journeyId]['new_registry']['id']
                        : undefined
                });
            }

            this.userComment = '';
            this.msgBox = false;
        }
        setTimeout(() => {
            this.processingRequest = false;
        }, 500);
    }

    gotoBottom() {
        setTimeout(() => {
            let commentsWrapper = this.$el.querySelector('#commentsWrapper')!;
            commentsWrapper.scrollTop = commentsWrapper.scrollHeight;
        }, 1000);
    }

    format(date: string) {
        return formatDate(date);
    }
}
